export const PERIOD_LABELS = {
  monthly: '1 mês',
  quarterly: '3 meses',
  semiannual: '6 meses',
  annual: '12 meses'
};

export function getPeriodLabel(period) {
  return PERIOD_LABELS[period] || period;
}

export function formatCurrency(value) {
  if (value === null || value === undefined) return 'R$ 0,00';

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
}
